import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MenuItem = ({
  IconComponent,
  text,
  to,
  style = {},
  textStyle = {},
  showText = true,
  compact = false,
  exact = false,
}) => {
  const location = useLocation();
  const isActive = Boolean(
    to &&
      (location.pathname === to ||
        (!exact && to !== '/app' && location.pathname.startsWith(`${to}/`)))
  );

  const content = (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: compact ? 'center' : 'flex-start',
        gap: showText ? '10px' : '0px',
        padding: compact ? '12px 10px' : '10px 20px',
        textDecoration: 'none',
        color: isActive ? 'var(--brand-primary, #2563eb)' : '#333',
        backgroundColor: isActive ? 'var(--brand-soft, #eff6ff)' : 'transparent',
        borderRight: isActive ? '3px solid var(--brand-primary, #2563eb)' : '3px solid transparent',
        fontWeight: isActive ? 700 : 500,
        transition: 'background-color 0.2s ease, color 0.2s ease',
        ...style,
      }}
      title={text}
    >
      {IconComponent && <IconComponent />}
      {showText && (
        <span
          style={{
            fontSize: '16px',
            fontWeight: 500,
            whiteSpace: 'nowrap',
            ...textStyle,
          }}
        >
          {text}
        </span>
      )}
    </div>
  );

  return to ? <Link to={to} style={{ textDecoration: 'none' }}>{content}</Link> : content;
};

export default MenuItem;
